export default __webpack_public_path__ + "static/media/logo-login.e8925d80.png";